import { Controller, useFormContext } from 'react-hook-form';

import {
  ReceptionFeaturesAutocomplete,
  type ReceptionFeaturesAutocompleteProps,
} from '@/components/form-controls/ReceptionFeaturesAutocomplete';

type RHFReceptionFeaturesAutocompleteProps = Omit<ReceptionFeaturesAutocompleteProps, 'renderInput' | 'value'> & {
  name: string;
};

export const RHFReceptionFeaturesAutocomplete = (props: RHFReceptionFeaturesAutocompleteProps) => {
  const { name, ...restOfProps } = props;
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, ...restFieldsProps } }) => {
        const reassignedOnChange: ReceptionFeaturesAutocompleteProps['onChange'] = (_, value) => {
          onChange(value);
        };

        return <ReceptionFeaturesAutocomplete {...restFieldsProps} onChange={reassignedOnChange} {...restOfProps} />;
      }}
    />
  );
};
